import { useEffect, useState } from "react";
import { Search, Edit2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SearchableDropdown from "../../reusableField/searchableDropdownField";
import "./architect.css";
import { BASE_URL } from "../../components/apiConfig";
import Loading from "./loading";
import { set } from "react-hook-form";

const ArchitectClientCards = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState({});
  const [clientRoles, setClientRoles] = useState({});
  const [rolesLoading, setRolesLoading] = useState({});
  const [clientname, setClientName] = useState();
  // const [noOfClients, setNoOfClients] = useState(0);
  const [isClientEmpty, setIsClientEmpty] = useState(false);

  useEffect(() => {
    const fetchClients = async () => {
      const token = localStorage.getItem("accessToken");
      try {
        const response = await fetch(`${BASE_URL}/client/client_list_assigned_to_Project_Architect`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch clients");
        }
        const data = await response.json();
        if (data.length === 0) {
          setIsClientEmpty(true);
        }
        setClientName(data.name);
        setClients(data.reverse());

        const initialRoles = {};
        const initialLoadingState = {};
        data.forEach((client) => {
          initialRoles[client.id] = null;
          initialLoadingState[client.id] = true;
        });
        setSelectedRoles(initialRoles);
        setRolesLoading(initialLoadingState);

        data.forEach((client) => {
          fetchClientRoles(client.id, token);
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  const fetchClientRoles = async (clientId, token) => {
    try {
      const response = await fetch(
        `${BASE_URL}/client/role_list_under_client_for_PA?client_id=${clientId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch roles for client ${clientId}`);
      }

      const rolesData = await response.json();
      const rolesArray = Array.isArray(rolesData) ? rolesData : [];

      setClientRoles((prev) => ({
        ...prev,
        [clientId]: rolesArray,
      }));
    } catch (err) {
      console.error(`Error fetching roles for client ${clientId}:`, err);
      setClientRoles((prev) => ({
        ...prev,
        [clientId]: [],
      }));
    } finally {
      setRolesLoading((prev) => ({
        ...prev,
        [clientId]: false,
      }));
    }
  };

  const handleRoleChange = (clientId, roleId) => {
    setSelectedRoles((prev) => ({
      ...prev,
      [clientId]: roleId,
    }));
  };

  const handleProject = (clientId) => () => {
    const roleId = selectedRoles[clientId];
    navigate(`/architect/${roleId}/projects`);
  };

  if (loading)
    return <div className="architect-loading">Loading clients...</div>;
  if (error) return <div className="architect-error">Error: {error}</div>;

  return (
    <>
      <div className="architect-sidebar"></div>
      {/* <div className="architect-container-header"> */}
      {isClientEmpty ? (
        <div className="architect-no-clients">No clients assigned.</div>
      ) : (
        <div className="architect-container-header">
          <div className="architect-container">
            <div className="architect-cards-grid">
              {clients.map((client) => {
                const roles = clientRoles[client.id] || [];
                const isRolesLoading = rolesLoading[client.id];

                return (
                  <div key={client.id} className="architect-client-card">
                    <div className="architect-client-header">
                      <div className="architect-client-logo">
                        <img src={client.image} alt={client.name} />
                      </div>
                    </div>
                    <div className="architect-client-content">
                      <h3 className="architect-client-name" title={client.name}>
                        {client.name}
                      </h3>
                      <div className="architect-dropdown-container">
                        {isRolesLoading ? (
                          <div className="architect-roles-loading">
                            Loading roles...
                          </div>
                        ) : (
                          // <Loading />
                          <SearchableDropdown
                            options={roles}
                            label="role_name"
                            id="id"
                            selectedVal={selectedRoles[client.id]}
                            handleChange={(roleId) =>
                              handleRoleChange(client.id, roleId)
                            }
                            placeholder="Select Role"
                          />
                        )}
                      </div>
                      <button
                        className="architect-view-role-btn"
                        disabled={
                          !selectedRoles[client.id] ||
                          selectedRoles[client.id] === ""
                        }
                        onClick={handleProject(client.id)}
                      >
                        View Project
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ArchitectClientCards;
